import { Game } from "@aura-frontend/omnibus-az-client";

import { getEventTimes } from "@/utils/eventUtils";

import { formatGameStartTime } from "../../../utils/formatGameStartTime";

type BattingPracticeModeInfoProps = {
  game: Game;
};

export const BattingPracticeModeInfo = ({
  game,
}: BattingPracticeModeInfoProps) => {
  const startTime = getEventTimes(game).startTime;

  return (
    <div className="mt-5 mb-5 w-full space-y-2">
      <div className="flex flex-row gap-2">
        <span className="font-bold text-text-light">Started at:</span>
        <span className="text-text-light">
          {formatGameStartTime(Number(startTime))}
        </span>
      </div>
    </div>
  );
};
